import { getRequest, type IValidatedResponse } from '../../httpClient';
import type { IGetProgressActivityV1Request } from './get-progress-activity-v1-request';
import type { IGetProgressActivityV1Response } from './get-progress-activity-v1-response';
import { getProgressActivityV1ResponseSchema } from './get-progress-activity-v1-response';

export async function getProgressActivityV1Api(
  params?: IGetProgressActivityV1Request,
): Promise<IValidatedResponse<IGetProgressActivityV1Response>> {
  return getRequest<IGetProgressActivityV1Response>({
    path: '/progress/activity/v1',
    schema: getProgressActivityV1ResponseSchema,
    options: {
      params: {
        timezoneOffsetMinutes: params?.timezoneOffsetMinutes,
        days: params?.days,
        cursor: params?.cursor,
      },
    },
  });
}
